import React from "react";

const CareerDevelopmentIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7594_31457"
        style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="17"
      >
        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7594_31457)">
        <path
          className="prompt-icon"
          d="M2.87314 14.1667C2.53636 14.1667 2.2513 14.05 2.01797 13.8167C1.78464 13.5833 1.66797 13.2983 1.66797 12.9615V6.0385C1.66797 5.70172 1.78464 5.41667 2.01797 5.18333C2.2513 4.95 2.53636 4.83333 2.87314 4.83333H5.66797V3.70517C5.66797 3.36839 5.78464 3.08333 6.01797 2.85C6.2513 2.61667 6.53636 2.5 6.87314 2.5H9.12947C9.46625 2.5 9.7513 2.61667 9.98464 2.85C10.218 3.08333 10.3346 3.36839 10.3346 3.70517V4.83333H13.1295C13.4662 4.83333 13.7513 4.95 13.9846 5.18333C14.218 5.41667 14.3346 5.70172 14.3346 6.0385V12.9615C14.3346 13.2983 14.218 13.5833 13.9846 13.8167C13.7513 14.05 13.4662 14.1667 13.1295 14.1667H2.87314ZM2.87314 13.1667H13.1295C13.1808 13.1667 13.2278 13.1453 13.2705 13.1025C13.3132 13.0598 13.3346 13.0128 13.3346 12.9615V6.0385C13.3346 5.98717 13.3132 5.94017 13.2705 5.8975C13.2278 5.85472 13.1808 5.83333 13.1295 5.83333H2.87314C2.8218 5.83333 2.7748 5.85472 2.73214 5.8975C2.68936 5.94017 2.66797 5.98717 2.66797 6.0385V12.9615C2.66797 13.0128 2.68936 13.0598 2.73214 13.1025C2.7748 13.1453 2.8218 13.1667 2.87314 13.1667ZM6.66797 4.83333H9.33463V3.70517C9.33463 3.65383 9.31325 3.60683 9.27047 3.56417C9.2278 3.52139 9.1808 3.5 9.12947 3.5H6.87314C6.8218 3.5 6.7748 3.52139 6.73214 3.56417C6.68936 3.60683 6.66797 3.65383 6.66797 3.70517V4.83333Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default CareerDevelopmentIcon;
